import Icon from "../../icon/index"
export default {
  components: {
    "ui-icon": Icon,
  },
  props: {
    raw: {
      type: Object,
    },
    closable: {
      type: Boolean,
      default: true,
    },
    onRemove: {
      type: Function,
      default() {},
    },
    label: {
      type: null,
    },
    value: {
      type: [String, Number],
    },
    maxTagTextLength: {
      type: Number,
    },
    maxTagWidth: {
      type: String,
    },
    renderTag: {
      type: Function,
    },
  },

  computed: {
    content() {
      let content = this.label || this.value
      if (
        this.maxTagTextLength &&
        typeof content === "string" &&
        content.length > this.maxTagTextLength
      ) {
        content = `${content.slice(0, this.maxTagTextLength)}...`
      }

      return content
    },
    choiceStyle() {
      const style = {}
      if (this.maxTagWidth) {
        style.maxWidth = this.maxTagWidth
      }
      return style
    },
  },
  methods: {
    removeHandler(event) {
      event.stopPropagation()
      this.$emit("remove", event, this.value)
      this.onRemove(event, this.value)
    },
  },
  render(h) {
    let content
    if (this.renderTag) {
      content = this.renderTag(h, {
        ...(this.raw || {
          label: this.label,
          value: this.value,
        }),
        remove: this.removeHandler,
      })
    } else {
      content = (
        <div class={"mm-selector-choice-content-container"}>
          <span class={"mm-selector-choice-content"}>{this.content}</span>
          {this.closable && (
            <ui-icon
              class={"mm-selector-choice-remove"}
              name="close"
              size="12px"
              onClick={this.removeHandler}
            />
          )}
        </div>
      )
    }
    return (
      <li
        class={{
          "mm-selector-choice": true,
          "mm-selector-choice--closable": this.closable,
        }}
        style={this.choiceStyle}
        title={this.label}
      >
        {content}
      </li>
    )
  },
}
